import React from 'react';
import styled from 'styled-components';
import search from '@design-system/Assets/Search.png';
import PropTypes from 'prop-types';
import { mediaQuery } from '@design-system/Breakpoints/Breakpoints';

const Box = styled.div`
  display: flex;
  align-items: center;
  align-content: stretch;
  width: 100%;
  border: 1px solid #eeeeee;
  border-radius: 8px;
  padding-right: 16px;

  input {
    padding: 16px;
    border: none;
    width: 100%;
    outline: none;
    background: transparent;
    font-size: 16px;
    font-weight: 600;
    color: #003232;
  }

  ${mediaQuery.desktop`

  display: flex;
  align-items: center;
  align-content: stretch;
  width: auto;
  border: 1px solid #eeeeee;
  border-radius: 8px;
  padding-right: 16px;


  
  input {
    padding: 16px;
    border: none;
    width: 170px;
    outline: none;
    background: transparent;
    font-size: 16px;
    font-weight: 600;
    color: #003232;
  }

  
   `}
`;

const SearchComponent = ({ handleSearch }) => {
  return (
    <Box>
      <input type="text" placeholder="Search" onChange={handleSearch} />
      <img src={search} alt="search_icon" />
    </Box>
  );
};

export default SearchComponent;

SearchComponent.propTypes = {
  handleSearch: PropTypes.func.isRequired,
};
